var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _rect2, _circle, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0088 30.0392H2.10007C1.75282 30.0392 1.41481 29.8949 1.16184 29.6299C0.908108 29.364 0.761719 28.9988 0.761719 28.6133V2.20104C0.761719 1.81556 0.908108 1.45028 1.16184 1.18447C1.41481 0.919444 1.75282 0.775146 2.10007 0.775146H21.0088C21.3561 0.775146 21.6941 0.919444 21.9471 1.18446L22.3059 0.841987L21.9471 1.18447C22.2008 1.45028 22.3472 1.81556 22.3472 2.20104V28.6133C22.3472 28.9988 22.2008 29.364 21.9471 29.6299C21.6941 29.8949 21.3561 30.0392 21.0088 30.0392Z",
    stroke: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10097 0.550255C1.68306 0.550255 1.28227 0.724174 0.986764 1.03375C0.691257 1.34333 0.525244 1.76321 0.525244 2.20102V28.6133C0.525244 29.0511 0.691257 29.471 0.986764 29.7805C1.28227 30.0901 1.68306 30.264 2.10097 30.264H21.0097C21.4277 30.264 21.8284 30.0901 22.1239 29.7805C22.4195 29.471 22.5855 29.0511 22.5855 28.6133V2.20102C22.5855 1.76321 22.4195 1.34333 22.1239 1.03375C21.8284 0.724174 21.4277 0.550255 21.0097 0.550255H2.10097ZM2.10097 0H21.0097C21.567 0 22.1013 0.231893 22.4954 0.644664C22.8894 1.05744 23.1107 1.61727 23.1107 2.20102V28.6133C23.1107 29.197 22.8894 29.7569 22.4954 30.1696C22.1013 30.5824 21.567 30.8143 21.0097 30.8143H2.10097C1.54376 30.8143 1.00937 30.5824 0.615361 30.1696C0.221352 29.7569 0 29.197 0 28.6133V2.20102C0 1.61727 0.221352 1.05744 0.615361 0.644664C1.00937 0.231893 1.54376 0 2.10097 0V0Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60547 21L19.6055 21",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60547 17L19.6055 17",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60547 13L19.6055 13",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6055 9H19.6055",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60547 25L19.6055 25",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.10547,
    y: 4.5,
    width: 5,
    height: 5,
    stroke: "#A3A3A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.547 17.9573C22.0272 21.8469 18.3991 24.5714 14.4436 24.0427C10.488 23.514 7.70287 19.9323 8.22274 16.0427C8.74262 12.1531 12.3707 9.42859 16.3262 9.95728C20.2818 10.486 23.0669 14.0677 22.547 17.9573Z",
    fill: "#303030"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5957,
    y: 20.9883,
    width: 8.99473,
    height: 4.34545,
    rx: 1,
    transform: "rotate(61.1578 20.5957 20.9883)",
    fill: "#303030"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3832,
    cy: 17.1372,
    r: 5.5347,
    transform: "rotate(7.61295 15.3832 17.1372)",
    fill: "#303030",
    stroke: "#A3A3A3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.5138,
    y1: 22.5557,
    x2: 22.4704,
    y2: 28.8405,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIcon);
export default __webpack_public_path__ + "static/media/review-icon.06dd4ecc715a431e140fa5d5291bf5c2.svg";
export { ForwardRef as ReactComponent };